import _extends from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Represents Media Text Component.
 * @author khushboo-harmeet
 */import React from 'react';
import Carousel from '../Carousel';
import TextCard from '../TextCard';
import Media from '../Media';
import styled from 'styled-components';
import FiftyFiftyCard from '../FiftyFiftyCard';
import styles from './MediaTextCarousel.style';
import CarouselArrow from '../../atoms/CarouselArrow';
import ImageOverlay from '../../atoms/ImageOverlay';
import analyticsConstants from '../../../constants/analyticsConstants';
import { imageRenditions } from './config';
var MediaTextCarouselBlock = styled.section.withConfig({
  componentId: "sc-1kqzeed-0"
})(["", ";"], styles);
var MediaTextCarousel = /*#__PURE__*/function (_React$Component) {
  _inherits(MediaTextCarousel, _React$Component);
  var _super = _createSuper(MediaTextCarousel);
  function MediaTextCarousel(props) {
    var _cards2;
    var _this;
    _classCallCheck(this, MediaTextCarousel);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleMessageReceived", function (event) {
      if (typeof event.data === 'string' && event.data !== 'recaptcha-setup') {
        var objMsg = JSON.parse(event.data);
        if (objMsg && objMsg.type === 'HOME_CAROUSEL_CARDS_UPDATED') {
          if (objMsg.content) {
            var cards = objMsg.content.filter(function (c) {
              return !c.fields.hideCard;
            }).map(function (c) {
              var _c$fields$backgroundI, _c$fields$backgroundI2;
              return _objectSpread(_objectSpread(_objectSpread({
                backgroundImage: {
                  altText: c.fields.backgroundImage.fields.altText,
                  image: _objectSpread({}, (_c$fields$backgroundI = c.fields.backgroundImage.fields.image) === null || _c$fields$backgroundI === void 0 ? void 0 : _c$fields$backgroundI.fields),
                  mobileImage: _objectSpread({}, (_c$fields$backgroundI2 = c.fields.backgroundImage.fields.mobileImage) === null || _c$fields$backgroundI2 === void 0 ? void 0 : _c$fields$backgroundI2.fields)
                }
              }, c.fields.video && {
                video: c.fields.video.fields
              }), {}, {
                headline: c.fields.headline,
                subHeadline: c.fields.subHeadline,
                textBlock: {
                  json: c.fields.textBlock
                },
                textLocation: c.fields.textLocation,
                fontColor: c.fields.fontColor,
                mobileCard: c.fields.mobileCard
              }, c.fields.cta && {
                cta: c.fields.cta.fields
              }), {}, {
                sys: c.sys
              });
            });
            _this.setState({
              cards: cards
            });
          }
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getCurrentPageCount", function (current, next) {
      _this.setState({
        currentPage: next
      });
    });
    var _cards = props.mediaTextCarouselData && props.mediaTextCarouselData.cardsCollection && props.mediaTextCarouselData.cardsCollection.items ? props.mediaTextCarouselData.cardsCollection.items : props.mediaTextCarouselData && props.mediaTextCarouselData.cards;
    _cards = (_cards2 = _cards) === null || _cards2 === void 0 ? void 0 : _cards2.filter(function (c) {
      return !c.hideCard;
    });
    _this.state = {
      currentPage: props.mediaTextCarouselData && props.mediaTextCarouselData.initialSlide || 0,
      cards: _cards
    };
    _this.totalPages = _cards && _cards.length;
    return _this;
  }
  _createClass(MediaTextCarousel, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(prevProps) {
      var _cards3;
      var cards = prevProps.mediaTextCarouselData && prevProps.mediaTextCarouselData.cardsCollection && prevProps.mediaTextCarouselData.cardsCollection.items ? prevProps.mediaTextCarouselData.cardsCollection.items : prevProps.mediaTextCarouselData && prevProps.mediaTextCarouselData.cards;
      cards = (_cards3 = cards) === null || _cards3 === void 0 ? void 0 : _cards3.filter(function (c) {
        return !c.hideCard;
      });
      this.setState({
        cards: cards
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('message', this.handleMessageReceived);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.handleMessageReceived);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var Settings = {};
      var textLocationClass = '';
      var mediaTextCarouselData = this.props.mediaTextCarouselData;
      if (!mediaTextCarouselData) {
        return null;
      }
      var height = this.props.height;
      var mobileHeroVariation = this.props.mobileHeroVariation;
      var isHero = this.props.isHero;
      var isGreaterThanPhone = this.props.isGreaterThanPhone;
      var isLessThanDesktop = this.props.isLessThanDesktop;
      var descriptionType = this.props.mediaTextCarouselData.descriptionType;
      var carouselArrows = {};
      if (mediaTextCarouselData.variationClass === 'variation-gallery-modal') {
        carouselArrows = {
          prevArrow: __jsx(CarouselArrow, {
            type: "previous",
            ariaLabel: "previous slide",
            analyticsType: analyticsConstants.galleryModal.analyticsType.CAROUSEL_ARROWS,
            analyticsValue: analyticsConstants.galleryModal.analyticsValue.PREV_ARROW
          }),
          nextArrow: __jsx(CarouselArrow, {
            ariaLabel: "next slide",
            type: "next",
            analyticsType: analyticsConstants.galleryModal.analyticsType.CAROUSEL_ARROWS,
            analyticsValue: analyticsConstants.galleryModal.analyticsValue.NEXT_ARROW
          })
        };
      } else {
        carouselArrows = {
          prevArrow: __jsx(CarouselArrow, {
            type: "previous"
          }),
          nextArrow: __jsx(CarouselArrow, {
            type: "next"
          })
        };
      }
      return __jsx(MediaTextCarouselBlock, {
        className: "nva-media-text-carousel nva-media-text-carousel--mobile-".concat(mobileHeroVariation, " media-Text-carousel")
      }, mediaTextCarouselData.variationClass === 'variation-gallery-modal' && __jsx("div", {
        className: "nva-media-text-carousel__card-numbers cardNumbers"
      }, __jsx("span", null, this.state.currentPage + 1, " of ", this.totalPages)), __jsx(Carousel, _extends({
        height: height,
        mobileHeroVariation: mobileHeroVariation,
        className: "".concat(mediaTextCarouselData.variationClass, " ").concat(height, " mobile-variation-").concat(mobileHeroVariation),
        classes: {
          carousel: 'nva-media-text-carousel__carousel',
          allTilesContainer: 'nva-media-text-carousel__all-tiles-container'
        },
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: mediaTextCarouselData.timePerSlide,
        styleType: mediaTextCarouselData.styleType,
        initialSlide: mediaTextCarouselData.initialSlide,
        dots: mediaTextCarouselData.dotsState,
        setCurrentCount: this.getCurrentPageCount,
        arrows: mediaTextCarouselData.arrows
      }, carouselArrows, Settings, {
        displayPlayPauseButton: isHero
      }), this.state.cards && this.state.cards.map(function (card, index) {
        if ((card === null || card === void 0 ? void 0 : card.__typename) === 'Panel') {
          var _card$cta, _card$ctaSecond, _card$cta2;
          var variation = card.variation;
          var text = card.shortText && card.shortText.shortText ? card.shortText.shortText : card.shortText && card.shortText.json ? card.shortText.json : null;
          var bladeBackgroundImage = card.bladeBackgroundImage && card.bladeBackgroundImage.image && card.bladeBackgroundImage.image.file ? card.bladeBackgroundImage.image.file.url : card.bladeBackgroundImage && card.bladeBackgroundImage.image && card.bladeBackgroundImage.image.url;
          var ctas = [];
          if (card !== null && card !== void 0 && (_card$cta = card.cta) !== null && _card$cta !== void 0 && _card$cta.url) ctas.push(card.cta);
          if (card !== null && card !== void 0 && (_card$ctaSecond = card.ctaSecond) !== null && _card$ctaSecond !== void 0 && _card$ctaSecond.url) ctas.push(card.ctaSecond);
          var dto = {
            isCurrentSlide: _this2.state.currentPage === index,
            className: "nva-media-text-carousel__50-50-card fifty-fifty-card row ".concat(variation),
            fontColor: card.fontColor,
            ariaLabel: card.cta ? ((_card$cta2 = card.cta) === null || _card$cta2 === void 0 ? void 0 : _card$cta2.label) || null : null,
            headingText: card.headline,
            isHero: isHero,
            isGreaterThanPhone: isGreaterThanPhone,
            subHeadingText: card.subHeadline,
            descriptionText: text,
            backgroundTheme: "".concat(card.backgroundTheme),
            overrideBackground: card.overrideBackground,
            imageSource: "".concat(bladeBackgroundImage),
            placeholderSrc: "".concat(bladeBackgroundImage),
            media: {
              image: card.bladeBackgroundImage,
              video: card.video || ''
            },
            alt: card.headline,
            cta: ctas,
            styleTypeAnchor: 'primary-anchor',
            styleType: 'fiftyFifty',
            classNameHeading: 'nva-media-text-carousel__50-50-card-heading fiftyFiftyHeading',
            classNameSubHeading: 'nva-media-text-carousel__50-50-card-sub-heading fiftyFiftySubHeading heading_four',
            classNamePara: 'nva-media-text-carousel__50-50-card-para fiftyFiftyPara',
            classNameAnchor: 'nva-media-text-carousel__50-50-card-anchor fiftyFiftyAnchor arrow cta_btn btn',
            dataAnalytics: {
              type: 'cta-50-50',
              value: card.headline,
              variation: variation
            },
            srcSetSetting: {
              imageRenditions: imageRenditions
            }
          };
          return __jsx(FiftyFiftyCard, dto);
        } else {
          var _card$sys;
          var backgroundImage = card.backgroundImage,
            video = card.video,
            headline = card.headline,
            subHeadline = card.subHeadline,
            textBlock = card.textBlock,
            textLocation = card.textLocation,
            fontColor = card.fontColor,
            mobileCard = card.mobileCard;
          var cta = card.cta;
          textLocationClass = textLocation && textLocation.replace(/\s+/g, '').toLowerCase();
          var textCardClass = video ? 'text-video ' + mediaTextCarouselData.variationClass + ' ' + textLocationClass : mediaTextCarouselData.variationClass + ' ' + textLocationClass;
          var descriptionJson = textBlock && (textBlock.json || textBlock.textBlock);
          var mobileDescriptionJson = mobileCard && mobileCard.textBlock && (mobileCard.textBlock.json || mobileCard.textBlock.textBlock || '');
          var mobileHeadline = mobileCard && mobileCard.headline || '';
          var mobileSubHeadline = mobileCard && mobileCard.subHeadline || '';
          if (cta) {
            cta = JSON.parse(JSON.stringify(cta));
            cta.styleType = mediaTextCarouselData.styleType === 'heroCarousel' ? 'hero-button' : 'primary-anchor';
            if (mediaTextCarouselData.analyticsAnchorCTA) {
              cta.anchorDataAnalyticsType = mediaTextCarouselData.analyticsAnchorCTA.analyticsType.CTA;
              cta.anchorDataAnalyticsValue = headline;
              cta.anchorDataAnalyticsVariation = mediaTextCarouselData.variation;
            }
          }
          var headingType = card.headingType;
          if ((card === null || card === void 0 ? void 0 : card.__typename) == 'HeroCard') {
            headingType = 'h2';
          }
          return __jsx("div", {
            key: index,
            className: "nva-media-text-carousel__item nva-media-text-carousel__item--".concat(index, " card-item")
          }, __jsx("div", {
            className: "nva-media-text-carousel__card-media card-media ".concat(video ? 'video' : '')
          }, __jsx(Media, {
            className: "nva-media-text-carousel__item-media ".concat(mediaTextCarouselData.variationClass),
            styleType: mediaTextCarouselData.styleType,
            video: video,
            videoSetting: mediaTextCarouselData.videoSettings,
            imageDetails: backgroundImage,
            blurDataURL: _this2.props.blurDataURL,
            srcSetSetting: isHero && _this2.props.shouldPreloadImage && index === 0 ? _objectSpread(_objectSpread({}, mediaTextCarouselData.srcSetSetting), {}, {
              priority: true
            }) : mediaTextCarouselData.srcSetSetting,
            imageOptimisationType: mediaTextCarouselData.imageOptimisationType,
            isHero: isHero,
            mobileHeroVariation: mobileHeroVariation,
            isGreaterThanPhone: isGreaterThanPhone,
            isLessThanDesktop: isLessThanDesktop,
            mobileCardBackgroundColor: mobileHeroVariation === 'full' && mobileCard && mobileCard.backgroundColor ? true : false
          })), __jsx("div", {
            className: "nva-media-text-carousel__card-text-wrapper card-text"
          }, __jsx(ImageOverlay, {
            className: "nva-media-text-carousel__card-text-container nva-media-text-carousel__card-text-container--".concat(card.fontColor === 'Light' ? 'dark' : 'light', " card-text-container ").concat(card.fontColor === 'Light' ? 'dark' : 'light').concat(mobileHeroVariation === 'full' && mobileCard && mobileCard.backgroundColor ? ' bg-color-override' : ''),
            background: mobileCard && mobileCard.backgroundColor
          }, __jsx(TextCard, {
            isCurrentSlide: _this2.state.currentPage === index,
            textLocation: textLocation,
            styleType: mediaTextCarouselData.styleType,
            className: "nva-media-text-carousel__item-text-card ".concat(textCardClass),
            headingText: !isGreaterThanPhone && mobileCard ? mobileHeadline : headline,
            subHeadingText: !isGreaterThanPhone && mobileCard ? mobileSubHeadline : subHeadline,
            headingType: headingType,
            headingTypeSubHeading: "h3",
            descriptionType: descriptionType,
            descriptionText: !isGreaterThanPhone && mobileCard ? mobileDescriptionJson : descriptionJson,
            cta: cta,
            fontColor: fontColor,
            isHero: isHero,
            entryId: card === null || card === void 0 ? void 0 : (_card$sys = card.sys) === null || _card$sys === void 0 ? void 0 : _card$sys.id
          }))));
        }
      })));
    }
  }]);
  return MediaTextCarousel;
}(React.Component);
export default styled(MediaTextCarousel).withConfig({
  componentId: "sc-1kqzeed-1"
})(["", ";"], styles);